"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineAppConfig = defineAppConfig;
/**
 * modules のデフォルト値（すべて無効）
 */
const DEFAULT_MODULES = {
    tutorial: false,
    trade: false,
    membership: false,
    thread: false,
    prepaidPoint: null,
    gacha: false,
    nft: false,
    liveStream: false,
    item: false,
    store: false,
    campaign: false,
    mission: false,
    resale: false,
    preSale: false,
    event: false,
    cart: false,
    pickup: false,
    eprint: false,
    konbiniPayment: false,
};
/**
 * @description
 * アプリ毎のコンフィグを定義するヘルパー関数
 * - デフォルト値を適用し、各configファイルの記述量を削減する
 * - applicationKeyから導出可能なフィールドを自動計算する
 * - modulesはデフォルト全てfalse/nullのため、有効なもののみ指定すればよい
 */
function defineAppConfig(input) {
    return {
        theme: input.theme ?? { dark: false },
        appName: input.appName,
        organizationId: input.organizationId,
        version: input.version ?? '1.0',
        ionicAppId: input.ionicAppId ?? '',
        applicationKey: input.applicationKey,
        applicationType: input.applicationType,
        artistId: input.artistId,
        languages: input.languages ?? ['ja', 'en'],
        ios: input.ios ?? { bundleId: '', appId: '' },
        android: input.android ?? { bundleId: '' },
        platform: input.platform ?? ['web'],
        custom: {
            modules: { ...DEFAULT_MODULES, ...input.custom.modules },
            tutorials: input.custom.tutorials ?? [],
            globalTabs: input.custom.globalTabs,
            artistTabs: input.custom.artistTabs,
            ...(input.custom.designUI !== undefined && {
                designUI: input.custom.designUI,
            }),
        },
        deeplinkUrl: input.deeplinkUrl,
        helpUrl: input.helpUrl,
        storagePath: input.storagePath ?? input.applicationKey,
        dynamicLinkPrefix: input.dynamicLinkPrefix ?? input.applicationKey,
        ...(input.applink !== undefined && { applink: input.applink }),
        ...(input.deeplinkDev !== undefined && { deeplinkDev: input.deeplinkDev }),
        ...(input.deeplinkStg !== undefined && { deeplinkStg: input.deeplinkStg }),
        ...(input.deeplinkProd !== undefined && {
            deeplinkProd: input.deeplinkProd,
        }),
        ...(input.calendarUrl !== undefined && { calendarUrl: input.calendarUrl }),
    };
}
